import React from 'react';
import {
  HomeOutlined,
  InboxOutlined,
  BarChartOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  PieChartOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  SettingOutlined,
  TeamOutlined,
  BuildOutlined,
  AccountBookOutlined,
  FileDoneOutlined,
  WalletOutlined,
  UserOutlined,
  BankOutlined,
  PlusOutlined,
  SendOutlined,
  CopyOutlined,
  CustomerServiceOutlined,
  SolutionOutlined,
  ReadOutlined,
} from '@ant-design/icons';
import { FiPackage, FiTruck } from 'react-icons/fi';

const MENU_ICONS = {
  dashboard: <HomeOutlined />,
  DELIVERY_LIST: <InboxOutlined />,
  DELIVERY_LIST_PRE_ORDER: <FiPackage />,
  DELIVERY_LIST_OPERATION: <FiTruck />,
  CREATE_DELIVERY: <PlusOutlined />,
  CREATE_SINGLE_DELIVERY: <SendOutlined />,
  CREATE_MULTIPLE_DELIVERY: <CopyOutlined />,
  REPORTS: <BarChartOutlined />,
  REPORTS_DELIVERY_SEARCH: <FileSearchOutlined />,
  REPORTS_DELIVERY_DETAIL: <FileTextOutlined />,
  REPORTS_DELIVERY_SUMMARY: <PieChartOutlined />,
  REPORTS_POD_DELIVERY: <DollarOutlined />,
  REPORTS_DELIVERY_DISTANCE: <EnvironmentOutlined />,
  REPORTS_DELIVERY_AREAS: <GlobalOutlined />,
  APP_MANAGEMENT: <SettingOutlined />,
  USER_MANAGEMENT: <TeamOutlined />,
  COMPANY_SETTINGS: <BuildOutlined />,
  INVOICES: <AccountBookOutlined />,
  INVOICE: <FileDoneOutlined />,
  PODS: <WalletOutlined />,
  info: <UserOutlined />,
  'company-info': <BankOutlined />,
  'solution-center': <CustomerServiceOutlined />,
  'support-tickets': <SolutionOutlined />,
  'support-documents': <ReadOutlined />,
};

const attachIcons = (items) =>
  items.map((item) => ({
    ...item,
    icon: MENU_ICONS[item.key] || null,
    children: item.children?.length ? attachIcons(item.children) : item.children,
  }));

const Transformer = {
  fetch: (data, dashboardDisabled) => {
    if (!data || !data.children) return [];

    const dashboard = {
      key: "dashboard",
      name: "Ana Sayfa",
      link: "/dashboard",
    };
    const info = {
      key: "info",
      name: "Bilgilerim",
      children: [
        {
          key: "company-info",
          name: "Firma Bilgilerim",
          link: "/info/company-info",
        },
      ],
    };
    const solutionCenter = {
      key: "solution-center",
      name: "Çözüm Merkezi",
      children: [
        {
          key: "support-tickets",
          name: "Destek Talepleri",
          link: "/cozummerkezi/destek-talepleri",
        },
        {
          key: "support-documents",
          name: "Destek Dokümanları",
          link: "/cozummerkezi/destek-dokumanlari",
        },
      ],
    };

    if (
      !data.children.find((x) => x.key === "dashboard") &&
      !dashboardDisabled
    ) {
      // her hot reloadda menüye bunu pushlamaması için
      data.children.unshift(dashboard);
    }
    if (!data.children.find((x) => x.key === "info")) {
      // her hot reloadda menüye bunu pushlamaması için
      data.children.push(info);
    }
    if (!data.children.find((x) => x.key === "solution-center")) {
      // her hot reloadda menüye bunu pushlamaması için
      data.children.push(solutionCenter);
    }

    return attachIcons(data.children);
  },
  recursiveIds: (item) => {
    if (item.id) return item.id;
  },
  getActivePaths: (obj, condition) => {
    const arr = [];
    const findChild = (obj, condition) => {
      if (
        Object.entries(condition).every(([k, v]) => {
          if (!v) return false;
          return obj[k] === v || v.includes(obj[k]);
        })
      ) {
        return obj;
      }
      for (const child of obj.children || []) {
        const found = findChild(child, condition);
        if (found) {
          arr.push(String(found.key));
          return Object.assign({}, obj, { children: [found] });
        }
      }
    };
    findChild(obj, condition);
    return {
      selectedKey: arr.slice(0, 1),
      openKeys: arr.slice(1),
    };
  },
};

export default Transformer;
